<template>
    <div>
        <el-row
            type="flex"
            justify="space-between"
            align="middle"
        >
            <el-col>
                <h2>{{ $t("view.demands.menu_option") }}</h2>
            </el-col>
            <el-col class="demands-header-action-buttons">
                <div class="row d-flex end-md">
                    <div
                        v-if="isUserAdmin()"
                        class="col-xs-12 col-md-auto"
                    >
                        <el-checkbox
                            v-model="displayHidden"
                            @change="getHidden"
                        >{{ $t('view.demands.display_all') }}</el-checkbox>
                    </div>
                    <div class="col-xs-12 col-md-auto">
                        <el-input
                            v-model="filter"
                            :placeholder="$t('view.demands.type_to_search')"
                            size="mini"
                            clearable
                        />
                    </div>
                    <div class="col-xs-12 col-md-auto">
                        <el-button
                            icon="el-icon-plus"
                            type="primary"
                            size="small"
                            plain
                            round
                            @click="$router.push({name: 'demands_new'})"
                        >
                            {{ $t("view.demands.create_demand_button") }}
                        </el-button>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-table
            ref="table"
            :loading="isDemandLoading()"
            :data="filterDemands(demands)"
            :default-sort="{prop: 'createTimestamp', order: 'descending'}"
            stripe
            fit
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <p><strong>{{ $t("view.demands.author") }}</strong>: {{ props.row.author.displayName }}</p>
                    <p><strong>{{ $t("view.demands.createdAt") }}</strong>:
                        {{ humanReadableDate(props.row.createTimestamp) }}</p>
                    <p><strong>{{ $t("view.demands.modifiedAt") }}</strong>:
                        {{ humanReadableDate(props.row.updateTimestamp) }}</p>
                </template>
            </el-table-column>
            <el-table-column :label="$t('view.demands.demand')">
                <template slot-scope="scope">
                    <span v-if="scope.row.author.id !== getUserID() && !isUserAdmin()">
                        <router-link
                            :to="{name: 'demands_chat', params: {id:scope.row.id}}"
                            class="el-dropdown-link"
                        >
                            {{ scope.row.title }}
                        </router-link>
                    </span>
                    <el-dropdown
                        v-if="scope.row.author.id === getUserID() || isUserAdmin()"
                        placement="bottom-start"
                        @command="handleDemandDropDownMenu($event, scope.row)"
                    >
                        <span class="el-dropdown-link">
                            {{ scope.row.title }}
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                        >
                            <el-dropdown-item
                                icon="el-icon-edit"
                                command="edit"
                            >
                                {{ $t("view.demands.edit_demand") }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-chat-dot-square"
                                command="chat"
                            >
                                {{ $t("view.demands.demand_chat") }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-delete"
                                command="delete"
                            >
                                {{ $t("view.demands.delete_demand") }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="$t('view.demands.demand_delete_modal_title')"
            :visible.sync="deleteDialog"
            width="30%"
        >
            <span
                v-html="$t('view.demands.demand_delete_confirm_message')"
            />
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="deleteDialog = false"
                    v-text="$t('view.demands.cancel')"
                />
                <el-button
                    type="primary"
                    @click="permanentlyDeleteEntry"
                    v-text="$t('view.demands.confirm')"
                />
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment                   from "moment";

export default {
    name: "Demands",
    data: () => (
        {
            demands       : [],
            filter        : "",
            deleteDialog  : false,
            demandToDelete: null,
            displayHidden : false
        }
    ),
    head() {
        return {
            title: {
                inner: this.$t("view.demands.demands_page_title")
            }
        };
    },
    async mounted() {
        if (this.getLocalDemands().length === 0) {
            await this.getDemands();
            this.demands = this.getLocalDemands();
        }

        this.demands = this.getLocalDemands();
    },
    methods: {
        ...mapActions(
            "demands",
            [
                "getDemands",
                "deleteDemand"
            ]
        ),
        ...mapGetters(
            "demands",
            [
                "isDemandLoading",
                "getLocalDemands"
            ]
        ),
        ...mapGetters(
            "authentication",
            [
                "getUserID",
                "isUserAdmin"
            ]
        ),
        humanReadableDate(date) {
            moment.locale("el");
            return moment(date).fromNow();
        },
        filterDemands(demands) {
            if (typeof undefined === typeof demands) {
                return [];
            }

            return demands.filter(
                demand => {
                    let found = true;

                    if (this.filter !== "") {
                        switch (true) {
                            case demand.author.displayName.toLocaleLowerCase()
                                       .indexOf(this.filter.toLocaleLowerCase()) !== -1:
                            case demand.author.email.toLocaleLowerCase()
                                       .indexOf(this.filter.toLocaleLowerCase()) !== -1:
                            case demand.author.role.toLocaleLowerCase().indexOf(this.filter.toLocaleLowerCase()) !== -1:
                            case demand.title.toLocaleLowerCase().indexOf(this.filter.toLocaleLowerCase()) !== -1:
                            case demand.description.toLocaleLowerCase().indexOf(this.filter.toLocaleLowerCase()) !== -1:
                            case demand.notification_body.toLocaleLowerCase()
                                       .indexOf(this.filter.toLocaleLowerCase()) !== -1:
                                found = true;
                                break;
                            default:
                                found = false;
                        }
                    }

                    return found;
                }
            );
        },
        async handleDemandDropDownMenu(command, row) {
            switch (command) {
                case "edit":
                    this
                        .$router
                        .push(
                            {
                                name  : "demands_edit",
                                params: {
                                    id: row.id
                                }
                            }
                        );
                    break;
                case "chat":
                    this
                        .$router
                        .push(
                            {
                                name  : "demands_chat",
                                params: {
                                    id: row.id
                                }
                            }
                        );
                    break;
                case "delete":
                    this.demandToDelete = row;
                    this.deleteDialog   = true;
                    break;
                default:
                    return null;
            }

            return null;
        },
        async permanentlyDeleteEntry() {
            const demandTitle = this.demandToDelete.title;

            await this.deleteDemand(this.demandToDelete.id);
            this.demandToDelete = null;
            this.deleteDialog   = false;

            this
                .$notify(
                    {
                        title                   : this.$t("view.demands.demands_notification_title"),
                        message                 : this.$t("view.demands.demands_notification_message", {demandTitle}),
                        type                    : "success",
                        dangerouslyUseHTMLString: true
                    }
                );
        },
        async getHidden() {
            await this.getDemands(this.displayHidden);
            this.demands = this.getLocalDemands();
        }
    }
};
</script>

<style scoped lang="scss">
.demands-header-action-buttons {
    text-align : right;
}

.el-dropdown-link {
    cursor          : pointer;
    color           : #409EFF;
    font-size       : 14px;
    text-decoration : none;
}

.el-icon-arrow-down {
    font-size : 12px;
}
</style>